﻿import { Annotations } from './annotations.mjs';
import TextContents  from './text_content.mjs';
import Images from './images.mjs';
import { Formulas } from './formulas.mjs';
/**
 * Class          : DataProxy
 * Author         : Pratheeshkumar N P
 * Created On     : 24-Apr-2025 
 * Other Fn calls :
 * Comments       :
 * ================================================================================================
 *   Last Modified By  ||    Date        ||    Purpose/Reason
 * ================================================================================================
 */
export default class DataProxy {
    constructor(name, settings, page, n, fieldEditor, formulaEditor) {
        this.settings = settings || {}; 
        this.name = name || 'page';
        this.pageIndex = n;
        this.styles = [];   
        this.fields = new Annotations(); 
        this.textContent = new TextContents();
        this.images = new Images();
        this.formulas = new Formulas();
        this.values = new Values(); 
        this.fieldEditor = fieldEditor;
        this.formulaEditor = formulaEditor;
        this.fieldEditor?.hide(); this.formulaEditor?.hide();
        this.page = page;
        
    }
    setData(d) {
        Object.keys(d).forEach((property) => {
            if (property === 'fields') {
                this[property].setData(d[property]);
                this[property].showFields(); 
            } else if (property === 'images') {
                this[property].setData(d[property]);
            }
            else if (property === 'textContent' || property === 'formulas') {
                 
            }
            else if (d[property] !== undefined) {
                this[property] = d[property];
            }
        });
        return this;
    }
    
    getData() {
        const { fields, name, pageIndex, images, formulas, textContent } = this;   
        return { fields: fields.getData(), images: images.getData(), textContent: textContent.getData(), formulas: formulas.getData(), name, pageIndex };
;
    }
    async setValues(v) {
        await this.values.setData(v); 
    }
    getValues() {
        const { values } = this;
        return values.getData();
    }
    getCodes() {
        return this.fields.getCodes();
    }
    getNames() {
        return this.fields.getNames();
    }
}
class Values {
    constructor() {
        this._ = [];
        this.length = 0;
    }
    getValues() {
        return this._.map(it => it.getValue());
    }
    getData() {
        return this._.map(it => it.getData());
    }
    async setData(v) {
        return new Promise((resolve) => { 
            const dataMap = new Map(v.map(d => [d.id, d]));   

            for (let i = 0; i < this._.length; i++) {
                const item = this._[i];  
                if (!item) continue; 
                const match = dataMap.get(item.id);
                if (match) {
                    item.setValue(match.value);
                } else {
                    item.setValue(null);
                }
            }
            
            resolve();
        });
    }
    add(d) {
        const n = new Value(d)
        this._.push(n);
        this.length = this._.length;
    }
    getNode(i) {
        if (i === undefined) {
            return this._[0];
        }
        else if (i === -1) {
            return null;
        } else {
            return this._[i];
        }
    }
    getById(id) {
        const index = this._.findIndex(f => f.id === id);
        return this.getNode(index);
    }
    getByCode(code) {
        const index = this._.findIndex(f => f.code === code);
        return this.getNode(index);
    }
    getByCodes(s) {
        return this._.filter(f => s.includes(f.code));
    }
    getRawValues() {
        return this._;
    }
}
class Value {
    constructor({ id, type, code, isReport, name, value} = {}) {
        this.id = id;
        this.type = type;
        this.code = code;
        this.isReport = isReport;
        this.name = name;
        this.value = value != null ? String(value) : '';
    }

    setValue(v) {
        this.value = v != null ? String(v) : '';
    }

    getValue() {
        switch (this.type) {
            case 'checkbox':
            case 'radio':
                const val = String(this.value).toLowerCase().trim();
                return val === '1' || val === 'true';
            default:
                return this.value ?? '';
        }
    }   
    getData() {
        const { id, type, code, isReport, name, value } = this;
        return { id, type, code, isReport, name, value };
    }
}